import log from 'salvo-lite/log'
import Choices from 'choices.js'

class CurrencyConverterMod {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._eventListenerIsBound = false
    }

    onInit () {
        log.debug(this.constructor.name, 'initialised', this)

        // eslint-disable-next-line no-unused-vars
        const currencyChoices = new Choices('#CurrencyPicker-header', {
            searchEnabled: false,
            itemSelectText: ''
        })

        if (!this._eventListenerIsBound) {
            document.addEventListener('CURRENCY_UPDATED', () => {
                currencyChoices.setChoiceByValue(window.Currency.currentCurrency)
            })

            this._eventListenerIsBound = true
        }
    }
}

export default CurrencyConverterMod



// WEBPACK FOOTER //
// ./src/resources/scripts/components/CurrencyConverterMod.js